import Reveal from '@/components/feature/Reveal';
import SectionHeader from './SectionHeader';
import { SITE } from '@/config/site';

const products = [
  {
    name: 'PriviRooms',
    status: 'Próximo lanzamiento',
    statusColor: 'text-accent-400 border-accent-500/40 bg-accent-500/10',
    icon: 'ri-live-line',
    gradient: 'from-primary-500/20 to-accent-500/10',
    footerText: 'Próximo lanzamiento',
    footerIcon: 'ri-time-line',
    desc: 'Plataforma digital que conecta creadores y comunidades mediante experiencias en vivo y contenido exclusivo.',
    tags: ['Video en tiempo real', 'Pagos', 'Moneda virtual', 'Marketplace', 'Web', 'Mobile'],
    cta: 'Conocer PriviRooms',
    url: SITE.productUrls.privirooms,
  },
  {
    name: 'Contoo',
    status: 'En desarrollo',
    statusColor: 'text-secondary-400 border-secondary-500/40 bg-secondary-500/10',
    icon: 'ri-shape-2-line',
    gradient: 'from-accent-500/20 to-primary-500/10',
    footerText: 'En desarrollo',
    footerIcon: 'ri-loader-4-line',
    desc: 'Nuevo producto digital desarrollado por ACOMA.',
    tags: ['Próximamente'],
    cta: null,
    url: '',
  },
  {
    name: 'APR-Online',
    status: 'Disponible',
    statusColor: 'text-primary-400 border-primary-500/40 bg-primary-500/10',
    icon: 'ri-drop-line',
    gradient: 'from-secondary-500/20 to-primary-500/10',
    footerText: 'En producción',
    footerIcon: 'ri-checkbox-circle-line',
    desc: 'Plataforma integral para digitalizar la administración de sistemas de Agua Potable Rural en Chile.',
    tags: ['Gestión de socios', 'Lecturas', 'Consumos', 'Pagos', 'Documentos', 'Reportes', 'Integraciones'],
    cta: 'Conocer APR-Online',
    url: SITE.productUrls.aprOnline,
  },
];

export default function ProductsSection() {
  return (
    <section className="relative py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeader
          eyebrow="Productos y Proyectos"
          title="No solo desarrollamos software. Construimos productos."
          subtitle="ACOMA también crea y opera productos digitales propios. Eso nos obliga a enfrentar los mismos desafíos de producto, escalabilidad, pagos, usuarios y operación que enfrentan nuestros clientes."
        />

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
          {products.map((p, i) => (
            <Reveal key={p.name} delay={i * 100}>
              <div className="h-full flex flex-col rounded-lg border border-background-700/60 bg-background-900/50 overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:border-background-600">
                <div
                  className={`h-36 bg-gradient-to-br ${p.gradient} flex items-center justify-center relative`}
                >
                  <div className="w-16 h-16 rounded-2xl bg-background-950/60 backdrop-blur border border-background-700/60 flex items-center justify-center text-foreground-300">
                    <i className={`${p.icon} text-3xl`}></i>
                  </div>
                  <span
                    className={`absolute top-4 left-4 text-xs font-medium px-2.5 py-1 rounded-full border ${p.statusColor}`}
                  >
                    {p.status}
                  </span>
                </div>
                <div className="flex flex-col flex-1 p-6">
                  <h3 className="text-xl font-bold font-heading text-foreground-950">
                    {p.name}
                  </h3>
                  <p className="mt-3 text-sm text-foreground-500 leading-relaxed">
                    {p.desc}
                  </p>
                  <div className="mt-4 flex flex-wrap gap-2">
                    {p.tags.map((t) => (
                      <span
                        key={t}
                        className="text-xs text-foreground-400 px-2.5 py-1 rounded-md bg-background-800/70 border border-background-700/50"
                      >
                        {t}
                      </span>
                    ))}
                  </div>
                  <div className="mt-auto pt-5">
                    {p.cta && p.url ? (
                      <a
                        href={p.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-2 text-sm font-medium text-foreground-900 hover:text-primary-300 transition-colors cursor-pointer whitespace-nowrap"
                      >
                        {p.cta}
                        <i className="ri-arrow-right-up-line"></i>
                      </a>
                    ) : (
                      <span className="inline-flex items-center gap-2 text-sm font-medium text-foreground-400">
                        <i className={`${p.footerIcon} text-accent-400`}></i>
                        {p.footerText}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </Reveal>
          ))}

          {/* Future slot */}
          <Reveal delay={300}>
            <div className="h-full min-h-[280px] flex flex-col items-center justify-center rounded-lg border border-dashed border-background-700/60 text-center p-8">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-800 text-foreground-500">
                <i className="ri-add-line text-2xl"></i>
              </div>
              <p className="mt-4 text-sm text-foreground-500 font-medium">
                Nuevos productos en camino
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}